<template>
  <Breadcrumb :home="home" :model="items" />
  <h3 v-if="name != null">{{ $t(name) }}</h3>
  <h6 v-if="name != null">
    {{ $t("storage.singlestorage.label") }} {{ $t(name).toLowerCase() }}
  </h6>
  <StorageIngredient
    v-for="ingredient in ingredientsList"
    :key="ingredient.value"
    :ingredient-info="ingredient"
    :storage-type-id="activeStorageId"
  >
  </StorageIngredient>
</template>

<script>
import StorageIngredient from "../components/storage/StorageIngredient.vue";
import StorageService from "../service/StorageService.js";
export default {
  components: {
    StorageIngredient,
  },
  data() {
    return {
      storageService: null,
      storageApiResponse: null,
    };
  },
  created() {
    this.storageService = new StorageService();
  },
  computed: {
    home() {
      return { label: this.$t("storage.name"), to: "/storage" };
    },
    items() {
      return [{ label: this.name }];
    },
    languages: function() {
      return this.$store.getters["labels/languages"];
    },
    name: function() {
      return this.$store.getters["storage/name"];
    },
    activeStorageId: function() {
      return this.$store.getters["storage/activeStorageId"];
    },
    ingredientsList: function() {
      return this.$store.getters["storage/ingredientsList"];
    },
    storage: function() {
      return this.$store.getters["storage/getStorage"];
    },
    access_token: function() {
      return this.$store.getters["userdata/getAccessToken"];
    },
    user_id: function() {
      return this.$store.getters["profile/id"];
    },
    dataToSend: {
      get() {
        return this.$store.state.storage.dataToSend;
      },
      set(value) {
        return this.$store.commit("storage/setDataToSend", value);
      },
    },
  },
  async mounted() {
    this.storageApiResponse = await this.storageService.getStorageInfo(
      this.access_token,
      this.user_id
    );
    this.$store.commit("storage/setStorage", this.storageApiResponse);
    let storageItem = this.storageApiResponse.filter((item) => {
      return item.storageType.id === this.activeStorageId;
    });
    this.$store.commit(
      "storage/setVisibleStorageIngredients",
      storageItem[0].ingredients
    );
    let dataToSend = {
      storage: [],
    };
    this.storage.forEach((item) => {
      let ingredients = [];
      item.ingredients.forEach((ingredient) => {
        let unit = ingredient.unit ? ingredient.unit.id : null;
        ingredients.push({
          value: ingredient.value,
          ingredient: ingredient.ingredient.id,
          unit: unit,
        });
      });
      dataToSend.storage.push({
        storageType: item.storageType.id,
        ingredients: ingredients,
      });
    });
    this.dataToSend = dataToSend;
  },
  methods: {
    async importUnitTranslations() {
      let translations = new Array(this.languages.length);
      this.languages.forEach((elem, index) => {
        translations[index] = {};
        translations[index].locale = elem.code;
        translations[index].labels = {};
      });
      this.ingredients.forEach((elem) => {
        if (elem.unit.data) {
          var path = elem.unit.data.attributes.key;
          elem.unit.data.attributes.labels.data.forEach((label) => {
            let index = translations.findIndex(
              (x) => x.locale === label.attributes.locale
            );
            var value = label.attributes.value;
            var obj = translations[index].labels;
            var parts = path.split("."),
              part;
            var last = parts.pop();
            // eslint-disable-next-line no-cond-assign
            while ((part = parts.shift())) {
              if (typeof obj[part] != "object") obj[part] = {};
              obj = obj[part]; // update "pointer"
            }
            obj[last] = value;
          });
        }
      });
      translations.forEach((elem) => {
        let old = this.$i18n.getLocaleMessage(elem.locale);
        this.$i18n.setLocaleMessage(elem.locale, {
          ...old,
          ...elem.labels,
        });
      });
      this.$i18n;
    },
  },
};
</script>
<style scoped></style>
